import { root } from '~/app/root'

export
const router = root.$router
